import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import Styles from "./TruckListItem.module.scss";
import TruckIconSm from "../../../assets/images/truck_icon_small.png";
import TrackingIndicationChip from "../chips/TrackingIndicationChip";

const TruckListItem = ({
  vehRegNo = "Not Available",
  ownerName = "Not Available",
  mnfcName = "Not Available",
  onClickFunc = () => {},
  id = 0,
  hideDivider = false,
  compactMode = false,
  selectedItem = false,
  showTrackingChip = true
}) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          cursor: "pointer",
        }}
        className={
          selectedItem
            ? Styles["list-item-selected"]
            : Styles["list-item-unselected"]
        }
        onClick={() =>
          onClickFunc({
            id: id,
            vehRegNo: vehRegNo,
            ownerName: ownerName,
            mnfcName: mnfcName,
          })
        }
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "start",
            alignItems: "center",
            width: compactMode ? null : "50%",
          }}
        >
          <Box
            sx={{
              height: "55px",
              width: "55px",
              background: "#F5F5F5",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                height: "35px",
                width: "35px",
                backgroundImage: `url(${TruckIconSm})`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: compactMode ? "column" : "row",
              gap: compactMode ? "2px" : "0px",
              flexGrow: 1,
              justifyContent: "space-between",
              ml: "10px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: compactMode ? "5px" : "",
              }}
            >
              <Typography
                fontSize={"1rem"}
                fontWeight={700}
                sx={{
                  letterSpacing: "1px",
                }}
              >
                {vehRegNo.toUpperCase()}
              </Typography>
              {compactMode && showTrackingChip && <TrackingIndicationChip isTracking compactMode />}
            </Box>

            <Typography
              fontSize={"0.9rem"}
              fontWeight={500}
              sx={{
                width: "250px",
                textWrap: "wrap",
                opacity: compactMode ? "0.5" : "0.75",
                mr: compactMode ? null : "-125px",
              }}
            >
              {mnfcName}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "end",
            alignItems: "center",
          }}
        >
          <Typography
            fontSize={"0.9rem"}
            fontWeight={500}
            sx={{
              opacity: "0.75",
              textAlign: "end",
            }}
          >
            {ownerName}
          </Typography>
          {!compactMode && showTrackingChip && (
            <Box
              sx={{
                width: "80px",
                ml: "100px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "end",
              }}
            >
              <TrackingIndicationChip isTracking />
            </Box>
          )}
        </Box>
      </Box>
      {!hideDivider && (
        <Box
          sx={{
            width: "100%",
            height: "1px",
            background: "grey",
            opacity: "0.2",
          }}
        />
      )}
    </>
  );
};

TruckListItem.propTypes = {
  vehRegNo: PropTypes.string,
  ownerName: PropTypes.string,
  mnfcName: PropTypes.string,
  onClickFunc: PropTypes.func,
  id: PropTypes.number,
  compactMode: PropTypes.bool,
  selectedItem: PropTypes.bool,
  showTrackingChip: PropTypes.bool
};

export default TruckListItem;
